export default "__VITE_ASSET__562944fc__"